<template>
  <div class="overflow-scroll-y">
    <div class="card-header">
      <h2>目的に合わせて選ぶ</h2>
      <p v-if="false">
        作成した履歴書をPDFでダウンロードします。<br />メール送信、コンビニ印刷、ダウンロードボタンを押下すると自動でバックアップされます。
      </p>
      <p style="color: red" v-if="!$firebase.isAuthenticated">
        ※メール送信、コンビニ印刷、ダウンロード、ヤギのメール便はログインが必須となります。<br />下記のいずれかのボタンを選択後、ログインしてください。
      </p>
    </div>
    <div class="card-content">
      <div class="button-download-pdf">
        <div
          class="bnr_container"
          v-if="formatId == 'internship' && false"
          style="padding: 0"
        >
          <div class="bnr_item">
            <img
              v-if="!isSendedYagishIntern"
              @click="
                $eventHub.$emit('send-yagish-intern')
                isSendedYagishIntern = true
              "
              src="/static/renew_img/bnr/intern_yagish_bnr_20230414.png"
              alt="Yagishインターン"
            />
            <div class="bnr_txt" v-if="!isSendedYagishIntern">
              <ul style="font-size: 0.8rem; margin-left: 0; text-align: left">
                <li>
                  ※応募するバナーをクリックすると、作成した履歴書がYagishに送付されます。
                </li>
                <li>※選考に進む際はこちらからご連絡いたします。</li>
                <li>
                  ※インターンに関する採用情報は<a
                    href="https://www.yagish.jp/recruit-info/intern2023/"
                    target="_blank"
                    >こちら</a
                  >からご確認ください。
                </li>
              </ul>
            </div>
            <div class="bnr_txt" v-else>
              <ul style="font-size: 0.8rem; margin-left: 0">
                <li>履歴書が送付されました。ありがとございます</li>
              </ul>
            </div>
          </div>
        </div>
        <div
          v-if="$firebase.isAuthenticated && autoRTInfo && autoRTInfo.clientId"
          class="roxxrt_container"
        >
          <div class="roxxrt_container__flex">
            <img
              v-if="false"
              :src="autoRTInfo.logoImage"
              alt="Yagish*"
              class="roxxrt_img"
              @load="onAutoRtLogoLoad"
            />
            <p class="roxxrt_txt">
              <template v-if="!autoRTInfo.hide_yagish_terms">
                Yagishの<router-link
                  id="footer-link-terms"
                  :to="{ name: 'termsPage' }"
                  target="_blank"
                  >利用規約</router-link
                >、<router-link
                  id="footer-link-policy"
                  :to="{ name: 'policyPage' }"
                  target="_blank"
                  >個人情報保護方針</router-link
                >、<a
                  href="https://www.yagish.jp/privacy_policy/"
                  target="_blank"
                  >プライバシーポリシー</a
                ><br />
              </template>
              <span
                v-if="hasAutoRtPartnerTerms"
                v-html="autoRtPartnerTermsHtml"
              />
              <template v-else>
                {{ autoRTInfo.clientName }}の<a
                  :href="autoRTInfo.termurl"
                  target="_blank"
                  >利用規約</a
                >、<a :href="autoRTInfo.privacyurl" target="_blank">{{
                  autoRTInfo.privacyLabel || '個人情報保護方針'
                }}</a
                ><a
                  v-if="autoRTInfo.handlingurl"
                  :href="autoRTInfo.handlingurl"
                  target="_blank"
                  >、個人情報の取扱い</a
                ><a
                  v-if="autoRTInfo.occupationurl"
                  :href="autoRTInfo.occupationurl"
                  target="_blank"
                  >、取扱職種の範囲等の明示</a
                >を確認して{{
                  autoRTInfo.clientServiceName
                }}に登録することになります。
              </template>
              <br v-if="autoRTInfo.showTrailingBr" />
              ※ご経験やスキルに応じて求人をご案内する場合があります
            </p>
          </div>
          <p class="roxxrt_container__txt">
            <el-checkbox
              class="rt-agree-checkbox"
              v-model="isAgree"
              @change="onRtAgreeChange()"
            >
            </el-checkbox
            >&#x3000;規約に同意して無料相談を希望する
          </p>
        </div>

        <div id="completed-buttons" class="bnr_container" v-if="isWeekEndFlag">
          <div id="quickemail" class="bnr_itemWrapper">
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0">
                <el-button
                  id="quick-email-btn"
                  style="
                    width: 100%;
                    border: 0;
                    padding: 0;
                    background: #eff8f8;
                  "
                  :disabled="
                    !$deviceLib.isOnline || !localIsSendYagiEmailEnabled
                  "
                  @click="
                    handleYagiEmailClick('send-special-quickemail', formatId)
                  "
                >
                  <p>応募先企業に1クリックで送信</p>
                  <br />
                  <h3>ヤギのメール便<span>をつかう</span></h3>
                </el-button>
              </div>
              <img
                src="/static/renew2_img/quickemail_img20231122.png"
                alt="ヤギのメール便"
                style="border-radius: 0 0 10px 10px"
              />
            </div>
          </div>

          <div
            id="pdf-email"
            class="bnr_itemWrapper"
            v-if="$firebase.user && $firebase.user.emailVerified"
          >
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0">
                <el-button
                  :id="pdfMailBtnId"
                  style="
                    width: 100%;
                    border: 0;
                    padding: 0;
                    background: #eff8f8;
                  "
                  :disabled="!$deviceLib.isOnline || !localMailPdfEnabled"
                  @click="handleEventWithLoginCheck('mail-PDF')"
                >
                  <p>登録したメアドに送るメェ〜</p>
                  <br />
                  <h3>PDFをメールで送る</h3>
                </el-button>
              </div>
              <img
                src="/static/renew2_img/pdf_mail_20230929.png"
                alt="PDFメール"
                style="border-radius: 0 0 10px 10px"
              />
            </div>
          </div>
          <div id="pdf-email-none" class="bnr_itemWrapper" v-else>
            <div class="bnr_item">
              <div class="bnr_txt txt">
                <el-button
                  id="pdf-mail-btn"
                  style="
                    width: 100%;
                    border: 0;
                    padding: 0;
                    background: #eff8f8;
                  "
                  :disabled="!$deviceLib.isOnline"
                  @click="
                    $firebase.isAuthenticated
                      ? $eventHub.$emit('send-email-verification')
                      : handleEventWithLoginCheck('send-email-verification')
                  "
                >
                  <template v-if="$firebase.isAuthenticated">
                    <p>PDFファイルを</p>
                    <p>登録したメアドに送るためには</p>
                    <br />
                    <h3>確認メールで送る</h3>
                  </template>
                  <template v-else>
                    <p>ログインして</p>
                    <p>PDFファイルを</p>
                    <br />
                    <h3>メールで送る</h3>
                  </template>
                </el-button>
              </div>
              <p class="bnr_note">
                <a
                  href="https://www.yagish.jp/information/pdf_mail_setting/"
                  target="_blank"
                  rel="nofollow"
                  >※できない場合はこちら</a
                >
              </p>
              <p class="bnr_note" v-if="!$firebase.isAuthenticated">
                ※ログインが必要です。
              </p>
            </div>
          </div>

          <div id="combie" class="bnr_itemWrapper">
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0">
                <el-button
                  id="pdf-eprint-btn"
                  style="
                    width: 100%;
                    border: 0;
                    padding: 0;
                    background: #eff8f8;
                  "
                  @click="handleEventWithLoginCheck('show-preview-4conv')"
                >
                  <p>作った履歴書、今すぐ印刷するメェ〜！</p>
                  <br />
                  <h3>コンビニで今すぐ印刷<span>する</span></h3>
                </el-button>
              </div>
              <img
                src="/static/renew_img/print.png"
                alt="コンビニプリント"
                style="border-radius: 0 0 10px 10px"
              />
            </div>
          </div>

          <div id="quickmail" class="bnr_itemWrapper">
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0">
                <el-button
                  id="quick-mail-btn"
                  style="
                    width: 100%;
                    border: 0;
                    padding: 0;
                    background: #eff8f8;
                  "
                  :disabled="
                    !$deviceLib.isOnline || !localIsSendYagiPostEnabled
                  "
                  @click="sendSpecialPost"
                >
                  <p>履歴書送付は任せろメェ〜</p>
                  <br />
                  <h3>ヤギの宅配便<span>をつかう</span></h3>
                </el-button>
              </div>
              <img
                src="/static/renew_img/mailbuy.png"
                alt="ヤギの宅配便"
                style="border-radius: 0 0 10px 10px"
              />
            </div>
          </div>

          <div id="pdf-download" class="bnr_itemWrapper" v-if="false">
            <div class="bnr_item">
              <div class="bnr_txt txt">
                <el-button
                  :id="pdfDownloadBtnId"
                  style="
                    width: 100%;
                    border: 0;
                    padding: 0;
                    background: #eff8f8;
                  "
                  :disabled="!$deviceLib.isOnline || !localDownloadPdfEnabled"
                  @click="handleEventWithLoginCheck('download-PDF')"
                >
                  <p>端末に保存するメェ〜</p>
                  <br />
                  <h3>PDFをダウンロードする</h3>
                </el-button>
              </div>
              <p class="bnr_note">
                <a
                  href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget"
                  target="_blank"
                  rel="nofollow"
                  >※できない場合はこちら</a
                >
              </p>
            </div>
          </div>

          <div
            id="pdf-download"
            class="bnr_itemWrapper"
            v-if="isPdfDownloadButtonVisible"
          >
            <div class="bnr_item">
              <div class="bnr_txt" style="border-radius: 10px 10px 0 0">
                <el-button
                  :id="pdfDownloadBtnId"
                  style="
                    width: 100%;
                    border: 0;
                    padding: 0;
                    background: #eff8f8;
                  "
                  :disabled="!$deviceLib.isOnline || !localDownloadPdfEnabled"
                  @click="handleEventWithLoginCheck('download-PDF')"
                >
                  <p>端末に保存するメェ〜</p>
                  <br />
                  <h3>PDFをダウンロードする</h3>
                </el-button>
              </div>
              <img
                src="/static/renew2_img/pdf_download_20230929.png"
                alt="PDFダウンロード"
                style="border-radius: 0 0 10px 10px"
              />
            </div>
          </div>
        </div>

        <div
          id="completed-buttons"
          class="bnr_container"
          v-if="formatId == 'shiboudoukisho'"
        >
          <div id="combie" class="bnr_itemWrapper">
            <div class="bnr_item">
              <img
                src="/static/renew2_img/print_20231024.png"
                alt="コンビニプリント"
                id="pdf-eprint-btn"
                @click="handleEventWithLoginCheck('show-preview-4conv')"
              />
              <div class="bnr_txt">
                <el-button
                  id="pdf-eprint-btn"
                  style="
                    width: 100%;
                    border: 0;
                    padding: 0;
                    background: #eff8f8;
                  "
                  @click="handleEventWithLoginCheck('show-preview-4conv')"
                >
                  <p>作った履歴書、今すぐ印刷するメェ〜！</p>
                  <br />
                  <h3>コンビニで今すぐ印刷<span></span></h3>
                </el-button>
              </div>
            </div>
          </div>

          <div
            id="pdf-email"
            class="bnr_itemWrapper"
            v-if="$firebase.user && $firebase.user.emailVerified"
          >
            <div class="bnr_item free-icon">
              <img
                src="/static/renew2_img/mail_bnr_20231011.png"
                :id="pdfMailBtnId"
                :disabled="!$deviceLib.isOnline || !localMailPdfEnabled"
                @click="handleEventWithLoginCheck('mail-PDF')"
              />
              <div class="bnr_txt">
                <el-button
                  :id="pdfMailBtnId"
                  style="
                    width: 100%;
                    border: 0;
                    padding: 0;
                    background: #eff8f8;
                  "
                  :disabled="!$deviceLib.isOnline"
                  @click="handleEventWithLoginCheck('mail-PDF')"
                >
                  <span>
                    <p>登録したメアドに送るメェ〜</p>
                    <br />
                    <h3>自分にメール</h3>
                  </span>
                </el-button>
              </div>
              <p class="bnr_note">
                <a
                  href="https://www.yagish.jp/information/pdf_mail_setting/"
                  target="_blank"
                  rel="nofollow"
                  >※メールが受信できない場合はこちら</a
                >
              </p>
              <p class="bnr_note" v-if="!$firebase.isAuthenticated">
                ※ログインが必要です。
              </p>
            </div>
          </div>
          <div id="pdf-email-none" class="bnr_itemWrapper" v-else>
            <div
              class="bnr_item"
              :class="{
                'free-icon':
                  !$firebase.isAuthenticated ||
                  ($firebase.user && $firebase.user.emailVerified)
              }"
            >
              <img
                src="/static/renew2_img/mail_bnr_20231011.png"
                id="pdf-mail-btn"
                v-if="
                  !$firebase.isAuthenticated ||
                  ($firebase.user && $firebase.user.emailVerified)
                "
                :disabled="!$deviceLib.isOnline || !localMailPdfEnabled"
                @click="
                  $firebase.isAuthenticated
                    ? $eventHub.$emit('send-email-verification')
                    : handleEventWithLoginCheck('send-email-verification')
                "
              />
              <div class="bnr_txt">
                <el-button
                  id="pdf-mail-btn"
                  style="
                    width: 100%;
                    border: 0;
                    padding: 0;
                    background: #eff8f8;
                  "
                  :disabled="!$deviceLib.isOnline"
                  @click="
                    $firebase.isAuthenticated
                      ? $eventHub.$emit('send-email-verification')
                      : handleEventWithLoginCheck('send-email-verification')
                  "
                >
                  <template v-if="$firebase.isAuthenticated">
                    <span>
                      <p>PDFファイルを</p>
                      <p>登録したメアドに送るためには</p>
                      <br />
                      <h3>確認メールで送る</h3>
                    </span>
                  </template>
                  <template v-else>
                    <span>
                      <p>ログインしてPDFファイルを</p>
                      <br />
                      <h3>メールで送る</h3>
                    </span>
                  </template>
                </el-button>
              </div>
              <p class="bnr_note">
                <a
                  href="https://www.yagish.jp/information/pdf_mail_setting/"
                  target="_blank"
                  rel="nofollow"
                  >※メールが受信できない場合はこちら</a
                >
              </p>
              <p class="bnr_note" v-if="!$firebase.isAuthenticated">
                ※ログインが必要です。
              </p>
            </div>
          </div>

          <div
            id="pdf-download"
            class="bnr_itemWrapper"
            v-if="isPdfDownloadButtonVisible"
          >
            <div class="bnr_item free-icon">
              <img
                src="/static/renew2_img/download_bnr_20231011.png"
                :id="pdfDownloadBtnId"
                :disabled="!$deviceLib.isOnline"
                @click="handleEventWithLoginCheck('download-PDF')"
              />
              <div class="bnr_txt">
                <el-button
                  :id="pdfDownloadBtnId"
                  style="
                    width: 100%;
                    border: 0;
                    padding: 0;
                    background: #eff8f8;
                  "
                  :disabled="!$deviceLib.isOnline"
                  @click="handleEventWithLoginCheck('download-PDF')"
                >
                  <span class="">
                    <p>端末に保存するメェ〜</p>
                    <br />
                    <h3>端末に保存</h3>
                  </span>
                </el-button>
              </div>
              <p class="bnr_note">
                <a
                  href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget"
                  target="_blank"
                  rel="nofollow"
                  >※できない場合はこちら</a
                >
              </p>
            </div>
          </div>

          <div
            id="quickemail"
            class="bnr_itemWrapper"
            v-if="$globalVar.in_app_payments"
          >
            <div class="bnr_item">
              <img
                :src="currentImageUrl"
                alt="ヤギのメール便"
                :disabled="!$deviceLib.isOnline || !localIsSendYagiEmailEnabled"
                id="quick-email-btn"
                @click="
                  handleYagiEmailClick('send-special-quickemail', formatId)
                "
              />
              <div class="bnr_txt">
                <el-button
                  id="quick-email-btn"
                  style="
                    width: 100%;
                    border: 0;
                    padding: 0;
                    background: #eff8f8;
                  "
                  :disabled="
                    !$deviceLib.isOnline || !localIsSendYagiEmailEnabled
                  "
                  @click="
                    handleYagiEmailClick('send-special-quickemail', formatId)
                  "
                >
                  <p>{{ currentTextLabel }}</p>
                  <br />
                  <h3>企業に履歴書を送る/応募する</h3>
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <div id="completed-buttons" class="bnr_container" v-else>
          <div
            id="pdf-email"
            class="bnr_itemWrapper"
            v-if="$firebase.user && $firebase.user.emailVerified"
          >
            <div class="bnr_item free-icon">
              <img
                src="/static/renew2_img/mail_bnr_20231011.png"
                :id="pdfMailBtnId"
                :disabled="!$deviceLib.isOnline || !localMailPdfEnabled"
                @click="handleEventWithLoginCheck('mail-PDF')"
              />
              <div class="bnr_txt">
                <el-button
                  :id="pdfMailBtnId"
                  style="
                    width: 100%;
                    border: 0;
                    padding: 0;
                    background: #eff8f8;
                  "
                  :disabled="!$deviceLib.isOnline"
                  @click="handleEventWithLoginCheck('mail-PDF')"
                >
                  <span>
                    <p>登録したメアドに送るメェ〜</p>
                    <br />
                    <h3>自分にメール</h3>
                  </span>
                </el-button>
              </div>
              <p class="bnr_note">
                <a
                  href="https://www.yagish.jp/information/pdf_mail_setting/"
                  target="_blank"
                  rel="nofollow"
                  >※メールが受信できない場合はこちら</a
                >
              </p>
              <p class="bnr_note" v-if="!$firebase.isAuthenticated">
                ※ログインが必要です。
              </p>
            </div>
          </div>
          <div id="pdf-email-none" class="bnr_itemWrapper" v-else>
            <div
              class="bnr_item"
              :class="{
                'free-icon':
                  !$firebase.isAuthenticated ||
                  ($firebase.user && $firebase.user.emailVerified)
              }"
            >
              <img
                src="/static/renew2_img/mail_bnr_20231011.png"
                id="pdf-mail-btn"
                v-if="
                  !$firebase.isAuthenticated ||
                  ($firebase.user && $firebase.user.emailVerified)
                "
                :disabled="!$deviceLib.isOnline || !localMailPdfEnabled"
                @click="
                  $firebase.isAuthenticated
                    ? $eventHub.$emit('send-email-verification')
                    : handleEventWithLoginCheck('send-email-verification')
                "
              />
              <div class="bnr_txt">
                <el-button
                  id="pdf-mail-btn"
                  style="
                    width: 100%;
                    border: 0;
                    padding: 0;
                    background: #eff8f8;
                  "
                  :disabled="!$deviceLib.isOnline"
                  @click="
                    $firebase.isAuthenticated
                      ? $eventHub.$emit('send-email-verification')
                      : handleEventWithLoginCheck('send-email-verification')
                  "
                >
                  <template v-if="$firebase.isAuthenticated">
                    <span>
                      <p>PDFファイルを</p>
                      <p>登録したメアドに送るためには</p>
                      <br />
                      <h3>確認メールで送る</h3>
                    </span>
                  </template>
                  <template v-else>
                    <span>
                      <p>ログインしてPDFファイルを</p>
                      <br />
                      <h3>メールで送る</h3>
                    </span>
                  </template>
                </el-button>
              </div>
              <p class="bnr_note">
                <a
                  href="https://www.yagish.jp/information/pdf_mail_setting/"
                  target="_blank"
                  rel="nofollow"
                  >※メールが受信できない場合はこちら</a
                >
              </p>
              <p class="bnr_note" v-if="!$firebase.isAuthenticated">
                ※ログインが必要です。
              </p>
            </div>
          </div>

          <div id="combie" class="bnr_itemWrapper">
            <div class="bnr_item">
              <img
                src="/static/renew2_img/print_20231024.png"
                alt="コンビニプリント"
                id="pdf-eprint-btn"
                @click="handleEventWithLoginCheck('show-preview-4conv')"
              />
              <div class="bnr_txt">
                <el-button
                  id="pdf-eprint-btn"
                  style="
                    width: 100%;
                    border: 0;
                    padding: 0;
                    background: #eff8f8;
                  "
                  @click="handleEventWithLoginCheck('show-preview-4conv')"
                >
                  <p>作った履歴書、今すぐ印刷するメェ〜！</p>
                  <br />
                  <h3>コンビニで今すぐ印刷<span></span></h3>
                </el-button>
              </div>
            </div>
          </div>

          <div
            id="quickemail"
            class="bnr_itemWrapper"
            v-if="
              $globalVar.in_app_payments &&
              formatId != 'rirekisho_design_001' &&
              formatId != 'rirekisho_design_002' &&
              formatId != 'shokumukeirekisho_with_image' &&
              formatId != 'taishokutodoke'
            "
          >
            <div class="bnr_item">
              <p>{{ getDate }}</p>

              <!--A.(2025.11.26~)-->
              <img
                :src="currentImageUrl"
                alt="ヤギのメール便"
                :disabled="!$deviceLib.isOnline || !localIsSendYagiEmailEnabled"
                id="quick-email-btn"
                @click="
                  handleYagiEmailClick('send-special-quickemail', formatId)
                "
              />

              <!--B.(2025.12.03~)-->

              <!--C.(2025.12.10~)-->

              <!--D.(2025.12.17~)-->

              <!--基本-->
              <!--<img src="/static/renew2_img/quickemail_new_btn_20250520.jpg" alt="ヤギのメール便"
                :disabled="!$deviceLib.isOnline || !localIsSendYagiEmailEnabled" id="quick-email-btn"
                @click="handleYagiEmailClick('send-special-quickemail', formatId)">-->

              <div class="bnr_txt">
                <el-button
                  id="quick-email-btn"
                  style="
                    width: 100%;
                    border: 0;
                    padding: 0;
                    background: #eff8f8;
                  "
                  :disabled="
                    !$deviceLib.isOnline || !localIsSendYagiEmailEnabled
                  "
                  @click="
                    handleYagiEmailClick('send-special-quickemail', formatId)
                  "
                >
                  <!--<p>{{ qemailBtnLabel }}</p>-->
                  <p>{{ currentTextLabel }}</p>
                  <br />
                  <h3>応募先にメール</h3>
                </el-button>
              </div>
            </div>
          </div>
          <div id="quickemail" class="bnr_itemWrapper" v-else-if="false">
            <div class="bnr_item">
              <img
                src="/static/renew2_img/quickemail_btn_20240221.png"
                alt="ヤギのメール便"
                :disabled="!$deviceLib.isOnline || !localIsSendYagiEmailEnabled"
                id="quick-email-btn"
                @click="
                  handleYagiEmailClick('send-special-newquickemail', formatId)
                "
              />
              <div class="bnr_txt">
                <el-button
                  id="quick-email-btn"
                  style="
                    width: 100%;
                    border: 0;
                    padding: 0;
                    background: #eff8f8;
                  "
                  :disabled="
                    !$deviceLib.isOnline || !localIsSendYagiEmailEnabled
                  "
                  @click="
                    handleYagiEmailClick('send-special-newquickemail', formatId)
                  "
                >
                  <p>{{ qemailBtnLabel }}</p>
                  <br />
                  <h3>応募先にメール<span></span></h3>
                </el-button>
              </div>
            </div>
          </div>

          <div
            id="pdf-download"
            class="bnr_itemWrapper"
            v-if="isPdfDownloadButtonVisible"
          >
            <div class="bnr_item free-icon">
              <img
                src="/static/renew2_img/download_bnr_20231011.png"
                :id="pdfDownloadBtnId"
                :disabled="!$deviceLib.isOnline"
                @click="handleEventWithLoginCheck('download-PDF')"
              />
              <div class="bnr_txt">
                <el-button
                  :id="pdfDownloadBtnId"
                  style="
                    width: 100%;
                    border: 0;
                    padding: 0;
                    background: #eff8f8;
                  "
                  :disabled="!$deviceLib.isOnline"
                  @click="handleEventWithLoginCheck('download-PDF')"
                >
                  <span class="">
                    <p>端末に保存するメェ〜</p>
                    <br />
                    <h3>端末に保存</h3>
                  </span>
                </el-button>
              </div>
              <p class="bnr_note">
                <a
                  href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget"
                  target="_blank"
                  rel="nofollow"
                  >※できない場合はこちら</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
      <!--<div class="button-download-wrapper" v-else>
        <login-forms />
      </div>-->
    </div>

    <div
      id="dl-useraim"
      v-if="false && formatId != 'rirekisho_esf_challenged' && abtest == 0"
    >
      <div class="card-content" v-if="$firebase.isAuthenticated">
        <div class="button-download-pdf">
          <!---->
          <div id="completed-buttons" class="pdf-download-box-wrap">
            <!--ここまでが共通-->

            <div class="pdf-download-box">
              <div class="left">
                <h3 class="h3">PDFを使う</h3>
                <div class="btn-list">
                  <img
                    src="/static/renew2_img/download_page_mail_20240425.png"
                    alt="PDFを使う"
                    class="btn-img"
                  />
                  <div
                    class="btn-item"
                    v-if="$firebase.user && $firebase.user.emailVerified"
                  >
                    <el-button
                      :id="pdfMailBtnId"
                      :disabled="!$deviceLib.isOnline || !localMailPdfEnabled"
                      @click="handleEventWithLoginCheck('mail-PDF')"
                    >
                      メールに送る
                    </el-button>
                    <a
                      href="https://www.yagish.jp/information/pdf_mail_setting/"
                      target="_blank"
                      class="notelink"
                      ><span class="notelink-icon">?</span
                      >メールが受信できない場合</a
                    >
                  </div>
                  <div class="btn-item" v-else>
                    <el-button
                      id="pdf-mail-btn"
                      :disabled="!$deviceLib.isOnline || !localMailPdfEnabled"
                      @click="
                        $firebase.isAuthenticated
                          ? $eventHub.$emit('send-email-verification')
                          : handleEventWithLoginCheck('send-email-verification')
                      "
                    >
                      <template v-if="$firebase.isAuthenticated">
                        認証メールで送る
                      </template>
                      <template v-else> ログインしてメールで送る </template>
                    </el-button>
                    <a
                      href="https://www.yagish.jp/information/pdf_mail_setting/"
                      target="_blank"
                      class="notelink"
                      ><span class="notelink-icon">?</span
                      >メールが受信できない場合</a
                    >
                  </div>
                  <div
                    class="btn-item"
                    v-if="
                      formatId != 'rirekisho_design_001' &&
                      formatId != 'rirekisho_design_002' &&
                      formatId != 'entrysheet' &&
                      $globalVar.in_app_payments
                    "
                  >
                    <el-button
                      id="quick-email-btn"
                      :disabled="
                        !$deviceLib.isOnline || !localIsSendYagiEmailEnabled
                      "
                      @click="
                        handleYagiEmailClick(
                          'send-special-quickemail',
                          formatId
                        )
                      "
                    >
                      企業にメール
                    </el-button>
                    <a href="/quickemailhelp" target="_blank" class="notelink"
                      ><span class="notelink-icon">?</span
                      >ヤギのメール便について</a
                    >
                  </div>
                </div>
              </div>
              <div
                class="right"
                v-if="
                  formatId != 'rirekisho_design_001' &&
                  formatId != 'rirekisho_design_002' &&
                  formatId != 'entrysheet'
                "
              >
                <h3 class="h3">紙に印刷</h3>
                <div class="btn-list">
                  <img
                    src="/static/renew2_img/download_page_paper_20240425.png"
                    alt="紙に印刷"
                    class="btn-img"
                  />
                  <div class="btn-item">
                    <el-button
                      id="pdf-eprint-btn"
                      @click="handleEventWithLoginCheck('show-preview-4conv')"
                    >
                      今すぐコンビニで印刷
                    </el-button>
                    <a tabindex="-1" class="notelink">※コンテンツ番号を発行</a>
                  </div>
                  <div class="btn-item" v-if="$globalVar.in_app_payments">
                    <el-button
                      id="quick-mail-btn"
                      :disabled="
                        !$deviceLib.isOnline || !localIsSendYagiPostEnabled
                      "
                      @click="sendSpecialPost"
                    >
                      企業に郵送代行
                    </el-button>
                    <a href="/quickmailhelp" target="_blank" class="notelink"
                      ><span class="notelink-icon">?</span
                      >ヤギの宅配便について</a
                    >
                  </div>
                </div>
              </div>
              <div class="bottom" v-if="isPdfDownloadButtonVisible">
                <div class="btn-item">
                  <el-button
                    :id="pdfDownloadBtnId"
                    :disabled="!$deviceLib.isOnline || !localDownloadPdfEnabled"
                    @click="handleEventWithLoginCheck('download-PDF')"
                  >
                    端末に保存
                  </el-button>
                  <a
                    href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget"
                    target="_blank"
                    class="notelink"
                    ><span class="notelink-icon">?</span
                    >端末に保存できない場合</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-content" v-else>
        <div class="text-center">
          <login-forms />
        </div>
      </div>
    </div>

    <div
      id="dl-useraim"
      v-else-if="false && formatId != 'rirekisho_esf_challenged' && abtest == 1"
    >
      <div class="card-content" v-if="$firebase.isAuthenticated">
        <div class="button-download-pdf">
          <!---->
          <div id="completed-buttons" class="pdf-download-box-wrap">
            <!--ここまでが共通-->

            <div class="pdf-download-box">
              <div class="left">
                <h3 class="h3">PDFを利用</h3>
                <div class="btn-list">
                  <img
                    src="/static/renew2_img/download_page_mail_20240509p1.png"
                    alt="PDFを使う"
                    class="btn-img"
                  />
                  <div
                    class="btn-item"
                    v-if="$firebase.user && $firebase.user.emailVerified"
                  >
                    <el-button
                      :id="pdfMailBtnId"
                      :disabled="!$deviceLib.isOnline || !localMailPdfEnabled"
                      @click="handleEventWithLoginCheck('mail-PDF')"
                    >
                      自分にメール
                    </el-button>
                    <a
                      href="https://www.yagish.jp/information/pdf_mail_setting/"
                      target="_blank"
                      class="notelink"
                      ><span class="notelink-icon">?</span
                      >メールが受信できない場合</a
                    >
                  </div>
                  <div class="btn-item" v-else>
                    <el-button
                      id="pdf-mail-btn"
                      :disabled="!$deviceLib.isOnline || !localMailPdfEnabled"
                      @click="
                        $firebase.isAuthenticated
                          ? $eventHub.$emit('send-email-verification')
                          : handleEventWithLoginCheck('send-email-verification')
                      "
                    >
                      <template v-if="$firebase.isAuthenticated">
                        認証メールで送る
                      </template>
                      <template v-else> ログインしてメールで送る </template>
                    </el-button>
                    <a
                      href="https://www.yagish.jp/information/pdf_mail_setting/"
                      target="_blank"
                      class="notelink"
                      ><span class="notelink-icon">?</span
                      >メールが受信できない場合</a
                    >
                  </div>
                  <div
                    class="btn-item"
                    v-if="
                      $globalVar.in_app_payments &&
                      formatId != 'rirekisho_design_001' &&
                      formatId != 'rirekisho_design_002' &&
                      formatId != 'entrysheet'
                    "
                  >
                    <el-button
                      id="quick-email-btn"
                      :disabled="
                        !$deviceLib.isOnline || !localIsSendYagiEmailEnabled
                      "
                      @click="
                        handleYagiEmailClick(
                          'send-special-quickemail',
                          formatId
                        )
                      "
                    >
                      応募先にメール
                    </el-button>
                    <a href="/quickemailhelp" target="_blank" class="notelink"
                      ><span class="notelink-icon">?</span
                      >ヤギのメール便について</a
                    >
                  </div>
                </div>
              </div>
              <div
                class="right"
                v-if="
                  formatId != 'rirekisho_design_001' &&
                  formatId != 'rirekisho_design_002' &&
                  formatId != 'entrysheet'
                "
              >
                <h3 class="h3">印刷して利用</h3>
                <div class="btn-list">
                  <img
                    src="/static/renew2_img/download_page_paper_20240509p1.png"
                    alt="紙に印刷"
                    class="btn-img"
                  />
                  <div class="btn-item">
                    <el-button
                      id="pdf-eprint-btn"
                      @click="handleEventWithLoginCheck('show-preview-4conv')"
                    >
                      今すぐコンビニで印刷
                    </el-button>
                    <a tabindex="-1" class="notelink">※コンテンツ番号を発行</a>
                  </div>
                  <div class="btn-item" v-if="$globalVar.in_app_payments">
                    <el-button
                      id="quick-mail-btn"
                      :disabled="
                        !$deviceLib.isOnline || !localIsSendYagiPostEnabled
                      "
                      @click="sendSpecialPost"
                    >
                      {{ qmailBtnLabel }}
                    </el-button>
                    <a href="/quickmailhelp" target="_blank" class="notelink"
                      ><span class="notelink-icon">?</span
                      >ヤギの宅配便について</a
                    >
                  </div>
                </div>
              </div>
              <div class="bottom" v-if="isPdfDownloadButtonVisible">
                <div class="btn-item">
                  <el-button
                    :id="pdfDownloadBtnId"
                    :disabled="!$deviceLib.isOnline || !localDownloadPdfEnabled"
                    @click="handleEventWithLoginCheck('download-PDF')"
                  >
                    端末に保存
                  </el-button>
                  <a
                    href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget"
                    target="_blank"
                    class="notelink"
                    ><span class="notelink-icon">?</span
                    >端末に保存できない場合</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-content" v-else>
        <div class="text-center">
          <login-forms />
        </div>
      </div>
    </div>

    <div
      id="dl-useraim"
      v-else-if="false && formatId != 'rirekisho_esf_challenged' && abtest == 2"
    >
      <div class="card-content" v-if="$firebase.isAuthenticated">
        <div class="button-download-pdf">
          <!---->
          <div id="completed-buttons" class="pdf-download-box-wrap">
            <!--ここまでが共通-->

            <div class="pdf-download-box">
              <div class="left">
                <h3 class="h3">PDFを利用</h3>
                <div class="btn-list">
                  <img
                    src="/static/renew2_img/download_page_mail_20240509p2.png"
                    alt="PDFを使う"
                    class="btn-img"
                  />
                  <div
                    class="btn-item"
                    v-if="$firebase.user && $firebase.user.emailVerified"
                  >
                    <el-button
                      :id="pdfMailBtnId"
                      :disabled="!$deviceLib.isOnline || !localMailPdfEnabled"
                      @click="handleEventWithLoginCheck('mail-PDF')"
                    >
                      自分にメール
                    </el-button>
                    <a
                      href="https://www.yagish.jp/information/pdf_mail_setting/"
                      target="_blank"
                      class="notelink"
                      ><span class="notelink-icon">?</span
                      >メールが受信できない場合</a
                    >
                  </div>
                  <div class="btn-item" v-else>
                    <el-button
                      id="pdf-mail-btn"
                      :disabled="!$deviceLib.isOnline || !localMailPdfEnabled"
                      @click="
                        $firebase.isAuthenticated
                          ? $eventHub.$emit('send-email-verification')
                          : handleEventWithLoginCheck('send-email-verification')
                      "
                    >
                      <template v-if="$firebase.isAuthenticated">
                        認証メールで送る
                      </template>
                      <template v-else> ログインしてメールで送る </template>
                    </el-button>
                    <a
                      href="https://www.yagish.jp/information/pdf_mail_setting/"
                      target="_blank"
                      class="notelink"
                      ><span class="notelink-icon">?</span
                      >メールが受信できない場合</a
                    >
                  </div>
                  <div
                    class="btn-item"
                    v-if="
                      $globalVar.in_app_payments &&
                      formatId != 'rirekisho_design_001' &&
                      formatId != 'rirekisho_design_002' &&
                      formatId != 'entrysheet'
                    "
                  >
                    <el-button
                      id="quick-email-btn"
                      :disabled="
                        !$deviceLib.isOnline || !localIsSendYagiEmailEnabled
                      "
                      @click="
                        handleYagiEmailClick(
                          'send-special-quickemail',
                          formatId
                        )
                      "
                    >
                      応募先にメール
                    </el-button>
                    <a href="/quickemailhelp" target="_blank" class="notelink"
                      ><span class="notelink-icon">?</span
                      >ヤギのメール便について</a
                    >
                  </div>
                </div>
              </div>
              <div
                class="right"
                v-if="
                  formatId != 'rirekisho_design_001' &&
                  formatId != 'rirekisho_design_002' &&
                  formatId != 'entrysheet'
                "
              >
                <h3 class="h3">印刷して利用</h3>
                <div class="btn-list">
                  <img
                    src="/static/renew2_img/download_page_paper_20240509p2.png"
                    alt="紙に印刷"
                    class="btn-img"
                  />
                  <div class="btn-item">
                    <el-button
                      id="pdf-eprint-btn"
                      @click="handleEventWithLoginCheck('show-preview-4conv')"
                    >
                      今すぐコンビニで印刷
                    </el-button>
                    <a tabindex="-1" class="notelink">※コンテンツ番号を発行</a>
                  </div>
                  <div class="btn-item" v-if="$globalVar.in_app_payments">
                    <el-button
                      id="quick-mail-btn"
                      :disabled="
                        !$deviceLib.isOnline || !localIsSendYagiPostEnabled
                      "
                      @click="sendSpecialPost"
                    >
                      郵送を依頼
                    </el-button>
                    <a href="/quickmailhelp" target="_blank" class="notelink"
                      ><span class="notelink-icon">?</span
                      >ヤギの宅配便について</a
                    >
                  </div>
                </div>
              </div>
              <div class="bottom" v-if="isPdfDownloadButtonVisible">
                <div class="btn-item">
                  <el-button
                    :id="pdfDownloadBtnId"
                    :disabled="!$deviceLib.isOnline || !localDownloadPdfEnabled"
                    @click="handleEventWithLoginCheck('download-PDF')"
                  >
                    端末に保存
                  </el-button>
                  <a
                    href="https://www.yagish.jp/information/2022-04-06-163828/?utm_source=blogWidget"
                    target="_blank"
                    class="notelink"
                    ><span class="notelink-icon">?</span
                    >端末に保存できない場合</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-content" v-else>
        <div class="text-center">
          <login-forms />
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.yagitaku {
  line-height: 25px;
  padding: 15px 0;
  font-weight: bold;
}

.yagitaku_recommend {
  color: #fff;
  background: #e3165c;
  padding: 5px 10px;
  margin-right: 5px;
  border-radius: 50px;
}

.yagitaku_link {
  color: #e3165c;
  border-bottom: 1px solid #e3165c;
}

.create-date_bnr {
  margin: 15px 0;
}

.el-button--success.overwrite.overwrite,
.el-button--primary.overwrite {
  color: #000;
  background: #eff8f8;
  border: none;
  display: block;
  padding: 0;
  border-radius: 15px;
  white-space: normal;
  line-height: 1.8;
}

.el-button--success.overwrite.overwrite:hover,
.el-button--primary.overwrite:hover {
  background: none;
  color: #000;
}

.addition {
  font-size: 0.75rem;
  margin: 0.5rem 0;
}

* {
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  vertical-align: bottom;
}

.next_bnr {
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}

.bnr_container {
  display: flex;
  flex-wrap: wrap;
  margin: calc(-30px / 2);

  // padding: 30px;
}

.bnr_itemWrapper {
  width: calc(100% / 2 - 30px);
  margin: calc(30px / 2);
}

.bnr_item {
  text-align: center;
}

.bnr_item img {
  border-radius: 10px 10px 0 0;
}

.bnr_txt {
  padding: 15px;
  background: #eff8f8;
  border-radius: 0 0 10px 10px;
}

.txt {
  border-radius: 10px;
}

.bnr_txt p {
  font-size: 0.8rem;
  font-weight: bold;
}

.bnr_txt h3 {
  color: #e3165c;
  font-size: 1.1rem;
  font-weight: bold;
}

.bnr_txt span {
  font-size: 0.8rem;
}

.create-date_txt {
  border-radius: 10px;
}

.bnr_note {
  font-size: 0.8rem;
}

.card-header h1 {
  padding-bottom: 1.5rem;
}

.card-header h2 {
  padding-bottom: 1.5rem;
}

/* タブレット 2カラム */
@media screen and (width <= 1024px) {
  .bnr_itemWrapper {
    width: calc(100% / 2 - 30px);
  }
}

/* スマホ 1カラム */
@media screen and (width <= 599px) {
  .bnr_itemWrapper {
    width: calc(100% / 1 - 30px);
  }
}

.free-icon {
  position: relative;
}

.free-icon::before {
  position: absolute;
  content: '';

  // background-image: url(/static/renew2_img/free_icon.png);
  width: 62px;
  height: 39px;
  background-size: contain;
  display: inline-block;
  top: 5px;
  left: 5px;
}
</style>
<style lang="scss" scoped>
#dl-2column .h3 {
  text-align: center;
  margin-bottom: 10px;
}

#dl-2column .pdf-download-box,
#dl-2column .pdf-eprint-box {
  margin-bottom: 30px;
}

#dl-2column .pdf-eprint-box .bnr_container {
  justify-content: center;
}

@media screen and (width <= 599px) {
  #dl-2column .card-content {
    padding-left: 0;
    padding-right: 0;
    border-top: 1px solid #f8f8f8;
  }

  #dl-2column .bnr_itemWrapper {
    width: calc(100% / 2 - 5px);
    margin: 0;
  }

  #dl-2column .bnr_container {
    justify-content: space-between;
    margin: 0;
  }

  #dl-2column .bnr_note {
    font-size: 0.6rem;
    margin-top: 8px;
  }

  #dl-2column .bnr_item img {
    border-radius: 5px 5px 0 0;
  }

  #dl-2column .bnr_txt {
    border-radius: 0 0 5px 5px;
  }
}
</style>
<style lang="scss" scoped>
#dl-disability .card-content {
  padding-top: 0;
}

#dl-disability .bnr_itemWrapper {
  width: 100%;
  margin: 0;
  background: #fff0f0;
  border-radius: 10px;
  border: 3px solid #e3165c;
  justify-content: center;
  align-items: center;
}

#dl-disability .bnr_txt {
  border-radius: 0;
  background: none;
  padding: 0 15px 10px;
}

#dl-disability .bnr_txt p {
  font-size: 14px;
  font-weight: normal;
  font-family: auto;
}

#dl-disability .bnr_txt p a {
  font-size: 12px;
}

#dl-disability .intro_icon {
  padding: 20px;
  width: 150px;
}

#dl-disability .request-btn {
  color: #fff;
  font-size: 1.2rem;
  font-weight: bold;
  padding: 10px 50px;
  margin-top: 10px;
  background: #e3165c;
  border-radius: 50px;
}

#dl-disability .note {
  font-size: 12px;
}

#dl-disability .edit-wrapper {
  margin-top: 30px;
  background: #eee;
  border-radius: 10px;
  padding: 20px;
}

#dl-disability .edit-wrapper .bnr_txt {
  justify-content: center;
  align-items: center;
  padding-bottom: 0;
}

#dl-disability .edit-wrapper .bnr_txt .edit-btn {
  padding: 5px 20px;
  background: #404040;
  color: #fff;
  border-radius: 50px;
  margin-left: 30px;
}

#dl-disability .other-action-block {
  margin-top: 50px;
}

#dl-disability .action-title {
  font-weight: bold;
  font-size: 15px;
  color: #004d40;
  margin-bottom: 10px;
  text-align: center;
}

#dl-disability .action-list {
  width: calc(100% / 3 - 10px);
  background: #eff8f8;
  border-radius: 10px;
  padding: 20px 10px 10px;
}

#dl-disability .other-action-block .flex {
  justify-content: space-between;
}

#dl-disability .el-button {
  border: none;
  padding: 0;
  background: no-repeat;
  color: #404040;
  font-weight: bold;
}

@media screen and (width <= 640px) {
  #dl-disability .flex {
    display: block;
  }

  #dl-disability .action-list {
    width: 100%;
    margin-bottom: 15px;
  }

  #dl-disability .bnr_txt {
    text-align: center;
    padding-bottom: 20px;
  }

  #dl-disability .edit-wrapper .bnr_txt .edit-btn {
    margin-left: 0;
    margin-top: 10px;
  }
}
</style>
<style lang="scss" scoped>
@import '@/assets/scss/variables';

#dl-useraim .pdf-download-box-wrap {
  background: #eef5e8;
  margin: 0 calc(50% - 50vw);
  width: 100vw;
}

#dl-useraim .card-content {
  padding: 0;
}

#dl-useraim .pdf-download-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 1.5rem;
  max-width: 630px;
  margin: 0 auto;
}

#dl-useraim .left,
#dl-useraim .right {
  width: 49%;
  background: #fff;
  border-radius: 10px;
}

#dl-useraim .h3 {
  text-align: center;
  color: #fff;
  letter-spacing: 0.1rem;
  background: #004d40;
  padding: 10px;
  border-radius: 10px 10px 0 0;
  font-size: 1rem;
}

#dl-useraim .btn-img {
  display: block;
  height: 80px;
  width: auto;
  margin: 0 auto;
}

#dl-useraim .btn-list {
  padding: 10px;
}

#dl-useraim .btn-item {
  margin: 10px auto 15px;
}

#dl-useraim .btn-item:last-child {
  margin-bottom: 0;
}

#dl-useraim .btn-item button {
  position: relative;
  width: 100%;
  border: none;
  background: #e3165c;
  color: #fff;
  font-weight: bold;
  box-shadow: 0 4px 0 #8c103a;
}

#dl-useraim .btn-item button::after {
  position: absolute;
  content: '';
  right: 10px;
  top: 50%;
  margin-top: -4px;
  width: 8px;
  height: 8px;
  border-top: 2px solid #fff;
  border-right: 2px solid #fff;
  transform: rotate(45deg);
}

#dl-useraim .notelink {
  display: block;
  font-size: 0.6rem;
  margin-top: 5px;
}

#dl-useraim .notelink-icon {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #404040;
  color: #fff;
  text-align: center;
  line-height: 15px;
  margin-right: 5px;
}

#dl-useraim .bottom {
  padding: 10px 10px 0;
  width: 49%;
}

#dl-useraim .bottom button {
  background: #fff;
  color: #404040;
  box-shadow: 0 4px 0 #004d40;
}

#dl-useraim .bottom .btn-item button::after {
  border-top: 2px solid #004d40;
  border-right: 2px solid #004d40;
}

#dl-useraim .btn-item button:hover {
  opacity: 1;
  transform: translateY(4px);
  box-shadow: none;
}

.roxxrt_container {
  text-align: center;
  font-size: 12px;

  @include max-width(sm) {
    font-size: 11px;
  }

  &__txt {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    line-height: 1.4;

    img {
      width: auto;
      height: 14px;
      object-fit: cover;
      margin-right: 4px;
    }

    // チェックボックス自体のスケール（インライン scale(1.4) で大きすぎていたものを縮小）
    .rt-agree-checkbox {
      transform: scale(0.9);
      transform-origin: right center;
      margin-right: 2px;

      @include max-width(sm) {
        transform: scale(0.85);
      }

      // チェック状態の色をプロジェクトテーマのピンクからグレーに上書き（scoped 配下のため ::v-deep）
      ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
      ::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #909399;
        border-color: #909399;
      }

      // フォーカス時の枠線色もグレーに合わせる
      ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #909399;
      }

      // ラベル文字色がチェック時にピンクへ変わる挙動も無効化
      ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
        color: inherit;
      }
    }
  }

  &__flex {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    padding: 4px 0 0;
    width: 90%;
    margin: 0 auto;

    @include max-width(sm) {
      padding: 4px 8px 0;
      width: 100%;
      gap: 8px;
    }

    .roxxrt_img {
      width: calc(50% - 6px);
      max-width: 220px;

      @include max-width(sm) {
        width: 100%;
        max-width: 180px;
      }
    }

    .roxxrt_txt {
      width: calc(50% - 6px);
      text-align: left;
      font-size: 11px;
      line-height: 1.5;

      @include max-width(sm) {
        width: 100%;
        font-size: 10px;
      }
    }
  }
}
</style>
<script>
import {
  computed,
  getCurrentInstance,
  nextTick,
  onBeforeMount,
  onBeforeUnmount,
  onMounted,
  ref,
  watch
} from 'vue'
import LoginForms from '@/components/auth/LoginSpecialForms'
import { useDownloadItemAutoRt } from '@/composables/useDownloadItemAutoRt'
import { autoRtState } from '@/composables/useAutoRtSession'
import { reportImageCacheStat } from '@/utils/image-cache-stats'
import { useLoginPopupTracking } from '@/composables/format-edit/useLoginPopupTracking'
import { LOGIN_POPUP_ABANDON_REASON } from '@/utils/login-popup-tracking'
import {
  emitter,
  emitOpenLoginDialog,
  LOGIN_SUCCESS,
  LOGIN_DIALOG_CLOSED,
  UPDATE_RT_CONDITION,
  AUTO_RT
} from '@/plugins/emitter'
import { useAuth } from '@/composables/useAuth'

export default {
  props: {
    formatId: {
      type: String
    },
    isSendYagiPostEnabled: {
      type: Boolean
    },
    isSendYagiEmailEnabled: {
      type: Boolean
    },
    mailPdfEnabled: {
      type: Boolean
    },
    downloadPdfEnabled: {
      type: Boolean
    },
    downloadActiveCollapses: {
      type: Array
    }
  },
  components: {
    'login-forms': LoginForms
  },
  setup(props) {
    const vm = getCurrentInstance().proxy
    const localIsSendYagiPostEnabled = ref(props.isSendYagiPostEnabled)
    const localMailPdfEnabled = ref(props.mailPdfEnabled)
    const localDownloadPdfEnabled = ref(props.downloadPdfEnabled)
    watch(
      () => props.isSendYagiPostEnabled,
      (value) => {
        localIsSendYagiPostEnabled.value = value
      }
    )
    watch(
      () => props.mailPdfEnabled,
      (value) => {
        localMailPdfEnabled.value = value
      }
    )
    watch(
      () => props.downloadPdfEnabled,
      (value) => {
        localDownloadPdfEnabled.value = value
      }
    )

    function sendSpecialPost() {
      emitter.emit('send-special-post', props.formatId)
      localIsSendYagiPostEnabled.value = false
    }

    function executeEvent(eventName, additionalParams = {}) {
      if (eventName === 'show-preview-4conv') {
        vm.$gtm.sendEprintEvent('cta_click', {
          format_id: props.formatId,
          click_location: 'download_item'
        })
      }

      if (eventName === 'send-email-verification') {
        localMailPdfEnabled.value = false
        if (vm.$firebase.user && vm.$firebase.user.emailVerified) {
          emitter.emit('mail-PDF', additionalParams)
        } else {
          emitter.emit('send-email-verification', additionalParams)
        }
        return
      }

      if (eventName === 'mail-PDF') {
        localMailPdfEnabled.value = false
      } else if (eventName === 'download-PDF') {
        localDownloadPdfEnabled.value = false
      }

      emitter.emit(eventName, additionalParams)
    }
    const isPdfDownloadButtonVisible = computed(() => vm.$site.appFlag !== 'b')

    const autoRtApi = useDownloadItemAutoRt(vm)
    vm._autoRt = autoRtApi

    const { isAuthenticated } = useAuth()
    let eprintCtaImpressionTracked = false
    let eprintCtaObserver = null

    function getLoginPopupTriggerButton(eventName) {
      switch (eventName) {
        case 'send-email-verification':
        case 'mail-PDF':
          return 'mail'
        case 'show-preview-4conv':
          return 'conv'
        case 'send-special-quickemail':
          return 'yagi'
        case 'download-PDF':
          return 'download'
        default:
          return eventName
      }
    }

    const loginPopupTracking = useLoginPopupTracking(vm.$gtm)

    function trackLoginPopupOpen(triggerButton) {
      loginPopupTracking.trackOpen(triggerButton, vm.formatId)
    }

    function handleLoginSuccess() {
      loginPopupTracking.trackLoginSuccess()

      if (vm.pendingYagiEmailEvent) {
        const { eventName, formatId } = vm.pendingYagiEmailEvent
        vm.executeYagiEmailEvent(eventName, formatId)
        vm.pendingYagiEmailEvent = null
      }

      if (vm.pendingEvent) {
        const { eventName, additionalParams } = vm.pendingEvent
        executeEvent(eventName, additionalParams)
        vm.pendingEvent = null
      }
    }

    function handleLoginDialogClosed() {
      loginPopupTracking.trackAbandon(LOGIN_POPUP_ABANDON_REASON.dialogClose)
    }

    const handleAutoRtMitt = (args) => autoRtApi.handleAutoRt(...args)
    const handleUpdateRtConditionMitt = (args) =>
      autoRtApi.handleUpdateRtCondition(...args)

    onBeforeMount(() => {
      emitter.on(AUTO_RT, handleAutoRtMitt)
      emitter.on(UPDATE_RT_CONDITION, handleUpdateRtConditionMitt)
      emitter.on(LOGIN_SUCCESS, handleLoginSuccess)
      emitter.on(LOGIN_DIALOG_CLOSED, handleLoginDialogClosed)
    })

    onMounted(() => {
      nextTick(() => {
        const eprintButtons = vm.$el.querySelectorAll('#pdf-eprint-btn')
        if (eprintButtons.length > 0 && 'IntersectionObserver' in window) {
          eprintCtaObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting && !eprintCtaImpressionTracked) {
                  eprintCtaImpressionTracked = true
                  vm.$gtm.sendEprintEvent('cta_impression', {
                    format_id: vm.formatId,
                    impression_location: 'download_item'
                  })
                  if (eprintCtaObserver) {
                    eprintCtaObserver.disconnect()
                  }
                }
              })
            },
            { threshold: 0.5 }
          )
          eprintCtaObserver.observe(eprintButtons[0])
        }
      })
    })

    onBeforeUnmount(() => {
      emitter.off(AUTO_RT, handleAutoRtMitt)
      emitter.off(UPDATE_RT_CONDITION, handleUpdateRtConditionMitt)
      emitter.off(LOGIN_SUCCESS, handleLoginSuccess)
      emitter.off(LOGIN_DIALOG_CLOSED, handleLoginDialogClosed)
      if (eprintCtaObserver) {
        eprintCtaObserver.disconnect()
        eprintCtaObserver = null
      }
    })

    function openLoginDialog() {
      emitOpenLoginDialog()
    }

    function handleYagiEmailClick(eventName, formatId) {
      if (!isAuthenticated.value) {
        vm.pendingYagiEmailEvent = { eventName, formatId }
        trackLoginPopupOpen(getLoginPopupTriggerButton(eventName))
        openLoginDialog()
        return
      }
      vm.executeYagiEmailEvent(eventName, formatId)
    }

    function handleEventWithLoginCheck(eventName, additionalParams = {}) {
      if (!isAuthenticated.value) {
        vm.pendingEvent = { eventName, additionalParams }
        trackLoginPopupOpen(getLoginPopupTriggerButton(eventName))
        openLoginDialog()
        return
      }
      executeEvent(eventName, additionalParams)
    }

    return {
      isPdfDownloadButtonVisible,
      localIsSendYagiPostEnabled,
      localMailPdfEnabled,
      localDownloadPdfEnabled,
      sendSpecialPost,
      openLoginDialog,
      handleYagiEmailClick,
      handleEventWithLoginCheck,
      ...autoRtApi.templateBindings,
      hasAutoRtPartnerTerms: autoRtApi.hasAutoRtPartnerTerms,
      autoRtPartnerTermsHtml: autoRtApi.autoRtPartnerTermsHtml
    }
  },
  data: function () {
    return {
      isWeekEndFlag: true,
      errors: [],
      abtest: 0,
      xmile_logo_img: '',
      pharmate_logo_img: '',
      recree_logo_img: '',
      isMaint: false,
      isSendedYagishIntern: false,
      localIsSendYagiEmailEnabled: true, // propの値をローカルで管理
      qemailBtnLabel: 'ポチッと企業に送信だメェ〜',
      qmailBtnLabel: '郵送を依頼',
      qemailBtnLabels20231113: [
        'ポチッと企業に送信だメェ〜',
        '提出までやっちゃうメェ〜',
        '1クリックで送信だメェ〜',
        'メールで提出は任せろメェ〜',
        'メールで送信まで任せてメェ〜'
      ],
      qemailBtnLabels: [
        'メールで企業に送信するなら⁉︎',
        'メールで効率的に企業に送信！',
        '履歴書を送って！と言われたら',
        '安全・安心に企業へ応募するなら',
        '1クリックで送信だメェ〜'
      ],
      pendingYagiEmailEvent: null, // ログイン待ちのヤギメールイベント情報を保存
      pendingEvent: null, // ログイン待ちの一般的なイベント情報を保存,
      isAgree: true,
      imageRules: [
        {
          image: '/static/renew2_img/quickemail_new_btn_A.png',
          start: '2025-11-26'
        },
        {
          image: '/static/renew2_img/quickemail_new_btn_B.png',
          start: '2025-12-03'
        },
        {
          image: '/static/renew2_img/quickemail_new_btn_C.png',
          start: '2025-12-10'
        },
        {
          image: '/static/renew2_img/quickemail_new_btn_D.png',
          start: '2025-12-17'
        },
        {
          image: '/static/renew2_img/quickemail_new_btn_20250311.jpg',
          start: '2026-03-11'
        },
        {
          image: '/static/renew2_img/quickemail_new_btn_20260407.jpg',
          start: '2026-04-07'
        },
        {
          image: '/static/renew2_img/quickemail_new_btn_20260419.png',
          start: '2026-04-19'
        }
      ],
      labelRules: [
        { label: '履歴書をPDFに変換してメールで送れる', start: '2025-11-26' },
        {
          label: 'ダウンロードの必要なし！履歴書を企業へ送信',
          start: '2025-12-03'
        },
        {
          label: 'パスワード付き！安全に履歴書(PDF)を送信！',
          start: '2025-12-10'
        },
        {
          label: 'ダウンロードも印刷も不要！企業へ直接送れる！',
          start: '2025-12-17'
        },
        { label: '企業名とメールアドレスを入れるだけ！', start: '2026-03-11' },
        {
          label: '予約送信で、時間や曜日を気にせず使える！',
          start: '2026-04-07'
        },
        { label: 'メール作成不要！ステップ入力で簡単！', start: '2026-04-19' }
      ],
      now: new Date()
    }
  },
  created: function () {
    const nowdate = new Date()
    const date1 = new Date('2023/09/29 00:00:00')
    const date2 = new Date('2023/10/06 23:59:59')
    if (nowdate > date1 && nowdate < date2) {
      this.isWeekEndFlag = true
    } else {
      this.isWeekEndFlag = false
    }
    const date21 = new Date('2023/11/01 12:00:00')
    const date22 = new Date('2023/11/07 18:00:00')
    if (nowdate > date21 && nowdate < date22) {
      this.isMaint = true
    } else {
      this.isMaint = false
    }

    const nowdate2 = new Date()
    const date12 = new Date('2024/05/05 00:00:00')
    const diffMilliSec = nowdate2 - date12
    /* ミリ秒を日数に変換 */
    const diffDays = parseInt(diffMilliSec / 1000 / 60 / 60 / 24)

    if (diffDays % 2 === 0) {
      this.abtest = 1
    } else {
      this.abtest = 2
    }

    const qmdate1 = new Date('2024/05/30 00:00:00')
    const qmdate2 = new Date('2024/06/06 00:00:00')
    const qmdate3 = new Date('2024/06/13 00:00:00')
    const qmdate4 = new Date('2024/06/20 00:00:00')
    if (nowdate >= qmdate1 && nowdate <= qmdate2) {
      this.qmailBtnLabel = '郵送を依頼'
    } else if (nowdate >= qmdate2 && nowdate <= qmdate3) {
      this.qmailBtnLabel = '配達依頼'
    } else if (nowdate >= qmdate3 && nowdate <= qmdate4) {
      this.qmailBtnLabel = '郵送を依頼'
    } else if (nowdate >= qmdate4) {
      this.qmailBtnLabel = '配達依頼'
    }
    this.qmailBtnLabel = '大切な履歴書を郵送してもらう'

    if (diffMilliSec < 0) {
      console.error(this.qemailBtnLabels[diffDays])
    } else if (diffDays > 4) {
      const _idx = diffDays % 5
      this.qemailBtnLabel = this.qemailBtnLabels[_idx]
    } else {
      this.qemailBtnLabel = this.qemailBtnLabels[diffDays]
    }
  },
  computed: {
    autoRTInfo: function () {
      return autoRtState.info
    },
    autoRtClientId: function () {
      return autoRtState.info && autoRtState.info.clientId
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    currentImageUrl() {
      // 1) 文字列 'YYYY-MM-DD' をローカル Date に変換
      const parseLocalYmd = (ymd) => {
        const [y, m, d] = ymd.split('-').map(Number)
        return new Date(y, m - 1, d)
      }
      // 2) Date -> YYYYMMDD の数値キー（時刻無視で比較）
      const dateKey = (date) => {
        const y = date.getFullYear()
        const m = String(date.getMonth() + 1).padStart(2, '0')
        const d = String(date.getDate()).padStart(2, '0')
        return Number(`${y}${m}${d}`)
      }

      const todayKey = dateKey(this.now)

      // 3) 開始日が today 以下のものを抽出し、その中で最も遅い開始日を選ぶ
      const eligible = this.imageRules
        .map((rule) => ({
          ...rule,
          startDate: parseLocalYmd(rule.start),
          startKey: dateKey(parseLocalYmd(rule.start))
        }))
        .filter((rule) => rule.startKey <= todayKey)
        .sort((a, b) => b.startKey - a.startKey) // 遅い開始日を優先

      // 4) 該当がなければ最初の画像（またはプレースホルダー）を返す
      return eligible.length > 0 ? eligible[0].image : this.imageRules[0].image
    },
    currentTextLabel() {
      // 1) 文字列 'YYYY-MM-DD' をローカル Date に変換
      const parseLocalYmd = (ymd) => {
        const [y, m, d] = ymd.split('-').map(Number)
        return new Date(y, m - 1, d)
      }
      // 2) Date -> YYYYMMDD の数値キー（時刻無視で比較）
      const dateKey = (date) => {
        const y = date.getFullYear()
        const m = String(date.getMonth() + 1).padStart(2, '0')
        const d = String(date.getDate()).padStart(2, '0')
        return Number(`${y}${m}${d}`)
      }

      const todayKey = dateKey(this.now)

      // 3) 開始日が today 以下のものを抽出し、その中で最も遅い開始日を選ぶ
      const eligible = this.labelRules
        .map((rule) => ({
          ...rule,
          startDate: parseLocalYmd(rule.start),
          startKey: dateKey(parseLocalYmd(rule.start))
        }))
        .filter((rule) => rule.startKey <= todayKey)
        .sort((a, b) => b.startKey - a.startKey) // 遅い開始日を優先

      // 4) 該当がなければ最初の画像（またはプレースホルダー）を返す
      return eligible.length > 0 ? eligible[0].label : this.labelRules[0].label
    }
  },
  watch: {
    // propの変更を監視してローカル状態を同期
    isSendYagiEmailEnabled: {
      handler(newVal) {
        this.localIsSendYagiEmailEnabled = newVal
      },
      immediate: true
    },
    autoRtClientId(newClientId) {
      if (!newClientId) return
      const info = this.autoRTInfo
      this._autoRt.notifyDisplay(
        this.formatId,
        newClientId,
        Number(info.permissionType) || 0
      )
    }
  },
  methods: {
    alertMaint: function () {
      this.$message({
        message:
          '以下の日時においてヤギの宅配便サービスの休止を行います。【利用一時休止期間】11/1 12:00 〜  11/7 18:00',
        type: 'error'
      })
    },
    onRtAgreeChange() {
      this._autoRt.setAgreed(!!this.isAgree)
    },
    onAutoRtLogoLoad(event) {
      const info = this.autoRTInfo
      reportImageCacheStat(event.target, {
        dialogName: 'auto_rt',
        clientId: info.clientId,
        permissionType: info.permissionType
      })
    },
    openDialogWithLogin(key) {
      console.log(key)
    },
    // ヤギメールイベントを実行する共通処理
    executeYagiEmailEvent(eventName, formatId) {
      // ローカル状態を無効化
      this.localIsSendYagiEmailEnabled = false
      // 親コンポーネントに状態変更を通知
      this.$emit('update:isSendYagiEmailEnabled', false)
      // イベントを発火
      this.$eventHub.$emit(eventName, formatId)
    },

    checkAutoRT(
      rtconditions,
      basicData,
      formatId,
      formatData,
      otherFormatData
    ) {
      this._autoRt.evaluateAutoRT(
        rtconditions,
        basicData,
        formatId,
        formatData,
        otherFormatData
      )
    }
  }
}
</script>
